export default import.meta.ROLLDOWN_FILE_URL_gLhonzD_NsmiMs4JsssZzg